import { Rarity } from "../../types/enum/Game"
import { Pkm, PkmDuo, type PkmProposition } from "../../types/enum/Pokemon"

export const PoolSize: { [key in Rarity]: [number, number, number] } = {
  [Rarity.COMMON]: [1, 18, 27],
  [Rarity.UNCOMMON]: [1, 13, 22],
  [Rarity.RARE]: [1, 9, 18],
  [Rarity.EPIC]: [1, 7, 14],
  [Rarity.ULTRA]: [1, 5, 10],
  [Rarity.UNIQUE]: [1, 1, 1],
  [Rarity.LEGENDARY]: [1, 1, 1],
  [Rarity.SPECIAL]: [0, 0, 0],
  [Rarity.HATCH]: [0, 0, 0]
}

export const UniquePool = new Array<PkmProposition>(
  Pkm.AERODACTYL,
  Pkm.CASTFORM,
  Pkm.UXIE,
  Pkm.MESPRIT,
  Pkm.AZELF,
  PkmDuo.LATIOS_LATIAS,
  Pkm.LAPRAS,
  Pkm.ABSOL,
  Pkm.SPIRITOMB,
  Pkm.ROTOM,
  Pkm.TAPU_KOKO,
  Pkm.TAPU_LELE,
  Pkm.SEVIPER,
  Pkm.KECLEON,
  Pkm.MAWILE,
  Pkm.TAUROS,
  Pkm.RELICANTH,
  Pkm.CHATOT,
  Pkm.FARFETCH_D,
  Pkm.GALARIAN_FARFETCH_D,
  Pkm.TAPU_BULU,
  Pkm.TAPU_FINI,
  Pkm.MIMIKYU,
  Pkm.TYROGUE,
  Pkm.ZERAORA,
  Pkm.SHUCKLE,
  Pkm.LUNATONE,
  Pkm.SOLROCK,
  Pkm.MILTANK,
  Pkm.MARACTUS,
  PkmDuo.PLUSLE_MINUN,
  Pkm.PINSIR,
  Pkm.DELIBIRD,
  Pkm.TORKOAL,
  Pkm.IRON_BUNDLE,
  Pkm.CHINGLING,
  Pkm.DHELMISE,
  Pkm.SPINDA,
  Pkm.HERACROSS,
  PkmDuo.ILLUMISE_VOLBEAT,
  Pkm.TANDEMAUS,
  Pkm.TROPIUS,
  Pkm.CARNIVINE,
  Pkm.HOOPA,
  Pkm.COMFEY,
  Pkm.SABLEYE,
  Pkm.DRACOVISH,
  Pkm.DRACOZOLT,
  Pkm.ARCTOVISH,
  Pkm.ARCTOZOLT,
  Pkm.GIMMIGHOUL,
  Pkm.BRUXISH,
  Pkm.CYCLIZAR,
  Pkm.MINIOR,
  Pkm.MORPEKO,
  Pkm.KANGASKHAN,
  Pkm.DRUDDIGON,
  Pkm.COSMOG,
  Pkm.SCYTHER,
  Pkm.ZANGOOSE,
  Pkm.SMEARGLE,
  Pkm.STANTLER,
  Pkm.KLEFKI,
  Pkm.HEATMOR,
  Pkm.HAWLUCHA,
  Pkm.STONJOURNER,
  Pkm.CRAMORANT,
  Pkm.PYUKUMUKU,
  Pkm.POIPOLE,
  Pkm.LUVDISC,
  Pkm.AUDINO,
  Pkm.MANTYKE,
  Pkm.DURANT,
  Pkm.SKARMORY,
  Pkm.SIGILYPH,
  Pkm.IRON_HANDS,
  Pkm.TURTONATOR,
  Pkm.CRYOGONAL,
  Pkm.DRAMPA,
  Pkm.APPLIN,
  Pkm.MILCERY,
  Pkm.VELUZA,
  Pkm.DURALUDON,
  Pkm.CHARCADET,
  Pkm.KUBFU,
  Pkm.SCREAM_TAIL,
  PkmDuo.INDEEDEE,
  Pkm.FURFROU,
  Pkm.EMOLGA,
  Pkm.TOGEDEMARU,
  Pkm.FALINKS_BRASS,
  Pkm.DEDENNE,
  Pkm.DUNSPARCE,
  Pkm.PACHIRISU,
  Pkm.QWILFISH,
  Pkm.HISUIAN_QWILFISH,
  PkmDuo.BASCULIN_RED_BLUE,
  Pkm.BASCULIN_WHITE,
  Pkm.FLUTTER_MANE,
  Pkm.ORTHWORM,
  Pkm.IRON_THORNS,
  Pkm.PINCURCHIN,
  Pkm.GREAT_TUSK,
  Pkm.FINIZEN,
  Pkm.DONDOZO,
  Pkm.EISCUE_NOICE,
  Pkm.KOMALA,
  Pkm.SLITHER_WING,
  Pkm.VESPIQUEN,
  Pkm.ORICORIO_BAILE,
  Pkm.ORICORIO_PA_U,
  Pkm.ORICORIO_POMPOM,
  Pkm.ORICORIO_SENSU,
  Pkm.PASSIMIAN
)

export const LegendaryPool = new Array<PkmProposition>(
  Pkm.KYUREM,
  Pkm.RESHIRAM,
  Pkm.ZEKROM,
  Pkm.STAKATAKA,
  Pkm.GENESECT,
  Pkm.GUZZLORD,
  Pkm.ETERNATUS,
  Pkm.MELOETTA,
  Pkm.MEW,
  Pkm.MEWTWO,
  Pkm.ENTEI,
  Pkm.SUICUNE,
  Pkm.RAIKOU,
  Pkm.REGIDRAGO,
  Pkm.REGIELEKI,
  Pkm.REGICE,
  Pkm.REGISTEEL,
  Pkm.REGIROCK,
  Pkm.REGIGIGAS,
  Pkm.CELEBI,
  Pkm.VICTINI,
  Pkm.JIRACHI,
  Pkm.ARCEUS,
  Pkm.DEOXYS,
  Pkm.SHAYMIN,
  Pkm.GIRATINA,
  Pkm.DARKRAI,
  Pkm.CRESSELIA,
  Pkm.HEATRAN,
  Pkm.LUGIA,
  Pkm.HO_OH,
  Pkm.PALKIA,
  Pkm.DIALGA,
  Pkm.RAYQUAZA,
  Pkm.KYOGRE,
  Pkm.GROUDON,
  Pkm.VOLCANION,
  Pkm.MARSHADOW,
  Pkm.XERNEAS,
  Pkm.YVELTAL,
  Pkm.ZAPDOS,
  Pkm.MOLTRES,
  Pkm.ARTICUNO,
  Pkm.SPECTRIER,
  Pkm.GLASTRIER,
  Pkm.KARTANA,
  Pkm.NECROZMA,
  Pkm.XURKITREE,
  Pkm.NIHILEGO,
  Pkm.PHEROMOSA,
  Pkm.BUZZWOLE,
  Pkm.TORNADUS,
  Pkm.THUNDURUS,
  Pkm.LANDORUS,
  Pkm.ENAMORUS,
  Pkm.MAGEARNA,
  Pkm.MELMETAL,
  Pkm.ZYGARDE_50,
  Pkm.TERRAKION,
  Pkm.VIRIZION,
  Pkm.COBALION,
  Pkm.KELDEO,
  Pkm.PECHARUNT,
  Pkm.ROARING_MOON,
  Pkm.ZACIAN,
  Pkm.IRON_VALIANT,
  Pkm.OKIDOGI,
  Pkm.MUNKIDORI,
  Pkm.FEZANDIPITI,
  Pkm.CELESTEELA,
  Pkm.OGERPON_TEAL,
  Pkm.OGERPON_WELLSPRING,
  Pkm.OGERPON_HEARTHFLAME,
  Pkm.OGERPON_CORNERSTONE,
  Pkm.MANAPHY,
  Pkm.CHI_YU,
  Pkm.TYPE_NULL,
  Pkm.BLACEPHALON
)
